import { ProjectType } from "../../../common/constants"
import api from "../../api"

export type InvoiceReportData = {
  jobId: number
  soldDateUtc: Date
  name: string
  unbilledAmount: number
  invoiceBalance: number
  finalPrice: number
  totalInvoicedAmount: number
  totalInvoiceBalance: number
  sold: boolean
  jobType: ProjectType
  customerDisplayName: string
  lastInvoiceDate: Date
}

export const getInvoiceReportData = async (startDate?: string, endDate?: string): Promise<InvoiceReportData[]> => {
  return (await api.get(`/web/datacenter/invoices/${startDate}/${endDate}`)).data
}
